import { MouseEvent } from "react";
import { H5, LI, UL } from "../../../../../../../AbstractElements";
import { Colors } from "../../../../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../../../../ReduxToolkit/Hooks";
import { filterColor } from "../../../../../../../ReduxToolkit/Reducers/ECommerce/FilterSlice";
import { getColors } from "../../../../../../../Utils/EcommerceService";

const ColorsFilter = () => {
  const { productItem } = useAppSelector((state) => state.product);
  const dispatch = useAppDispatch();
  const colors = getColors(productItem);

  const colorHandle = (event: MouseEvent<HTMLLIElement>, color: string) => {
    const elem = document.getElementsByClassName("color-selector")[0].getElementsByTagName("li");
    for (let i = 0; i < elem.length; i++) {
      elem[i].classList.remove("active");
    }
    (event.target as Element).classList.add("active");
    dispatch(filterColor(color));
  };

  return (
    <div className="product-filter slider-product">
      <H5>{Colors}</H5>
      <div className="color-selector">
        <UL className="d-flex flex-row gap-1 simple-list">
          {colors.map((color, i) => (
            <LI className={color} title={color} onClick={(e: MouseEvent<HTMLLIElement, globalThis.MouseEvent>) => colorHandle(e, color)} key={i}></LI>
          ))}
        </UL>
      </div>
    </div>
  );
};

export default ColorsFilter;
